import React, { ReactNode } from 'react';
import { Icon } from '@ant-design/compatible';

export const ErrorText = ({ children, style }: { children: ReactNode; style?: React.CSSProperties }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100px',
        padding: '1em',
        textAlign: 'center',
        ...style,
      }}>
      <Icon type="exclamation-circle" />
      <div style={{ paddingTop: '1em' }}>{children}</div>
    </div>
  );
};
